import React from 'react';
import AboutSection from '../components/AboutSection';

const About = () => {
  return (
    <div className="home-page">
      <AboutSection />
    </div>
  );
};

export default About;